module.exports = __webpack_public_path__ + "c066c8fcea7b98ce7322b199302c98a0.svg";